export default __webpack_public_path__ + "fonts/d90e0ad944d546651078a4f8c120c8a6f732bc0de7488b078877d1f06e0b09f5.ttf";